export const trending = [
    {
        bg: 'https://i03.appmifile.com/982_operator_in/05/09/2023/59a1b3745da869f2f61d6ec1c26a5d23.jpg?f=webp',
        name: 'Redmi Note 12 Pro+ 5G',
        para1: 'The Camera That Captures It All',
        price: '29,999'
    },
    {
        bg: 'https://i03.appmifile.com/55_operator_in/10/08/2023/91c71943fbf754b397c5b923fa54db17.jpg?f=webp',
        name: 'Xiaomi Smart TV X',
        para1: 'Series',
        price: '28,999'
    },
    {
        bg: 'https://i03.appmifile.com/900_operator_in/10/08/2023/4d1e1e75ddc8555e76500c8b21c768a6.jpg?f=webp',
        name: 'Redmi Note 12 5G',
        para1: 'Now Available in Sunrise Gold',
        price: '14,999'
    }
]